import {
    GETALLOCATEDMODULELISTFORSUBADMIN_SUCCESS,
    GETALLOCATEDMODULELISTFORSUBADMIN_FAILED,
    RESET_GETALLOCATEDMODULELISTFORSUBADMIN,
    LOADING_GETALLOCATEDMODULELISTFORSUBADMIN,
    NETWORK_ERROR_GETALLOCATEDMODULELISTFORSUBADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetGetAllocatedModuleListForSubAdmin = () => {
    return { type: RESET_GETALLOCATEDMODULELISTFORSUBADMIN };
};

const getAllocatedModuleListForSubadmin = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETALLOCATEDMODULELISTFORSUBADMIN });
    await adminServices
        .post("getAllocatedModuleListforSubAdmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                
                case "success":
                    dispatch(getAllocatedModuleListForSubAdminsuccess(res.data));
                    break;
                default:
                    dispatch(getAllocatedModuleListForSubAdminFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETALLOCATEDMODULELISTFORSUBADMIN,
                payload: err
            });
        });
};


function getAllocatedModuleListForSubAdminsuccess(data) {
    return {
        type: GETALLOCATEDMODULELISTFORSUBADMIN_SUCCESS,
        payload: data
    };
}
function getAllocatedModuleListForSubAdminFailed(data) {
    return {
        type: GETALLOCATEDMODULELISTFORSUBADMIN_FAILED,
        payload: data
    };
}

export { getAllocatedModuleListForSubadmin, resetGetAllocatedModuleListForSubAdmin }